<template lang="pug">
div.boxy
    div.loader
    label(v-if="showLabel") {{$t(labelText)}}...
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'BoxyLoader',
  props: { labelText: { default: 'Загрузка...' } },
  computed: {
    showLabel(): boolean {
      return Boolean(this.labelText.length > 0);
    },
  },
});
</script>

<style scoped lang="less">
    @loaderSize: 100px;
    @boxSize: @loaderSize + 60px * 2;

    .loader {
        font-size: @loaderSize;
        width: @loaderSize;
        height: @loaderSize;
        margin: 10px;
    }
    .boxy {
        width: @boxSize;
        height: @boxSize;
        background: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-radius: 15px;
    }
</style>

<i18n>
    {
        "en": {
            "Загрузка...": "Loading..."
        }
    }
</i18n>
